import React, { useRef } from "react";

import { Footer, Navbar, Sidebar } from "../Components";
import "./layout.css";
import AppRouter from "../Routers/AppRouter";
type Props = {};

const MainLayout = (props: Props) => {
  return (
    <>
      <Navbar />
      <div className="main-layout">
        <Sidebar />
        <div className="content">
          <AppRouter />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MainLayout;
